import {useState} from 'react';
import {TabPanel,type TabId} from './TabPanel';
import {AccountTab} from './AccountTab';
import {HeroesTab} from './HeroesTab';
import {InventoryTab} from './InventoryTab';
import {SideContentsTab} from './SideContentsTab';
import {RawTab} from './RawTab';
import type {CloudAllData} from '@/types/cloud-data';

/** The recovery page owns persistence. These are the same tabs as the player page. */
export function RecoveryDraftEditor({data,onSaveKey,readOnly}:{data:Record<string,string>;onSaveKey:(key:string,value:string)=>void;readOnly:boolean}) {
 const [tab,setTab]=useState<TabId>('account');
 let cloud:CloudAllData|null=null;
 try{cloud=JSON.parse(data.EC2_CLOUD_ALL_DATA);}catch{/* Raw tab can repair malformed JSON. */}
 const saveCloud=(next:CloudAllData)=>onSaveKey('EC2_CLOUD_ALL_DATA',JSON.stringify(next));
 return <div className="space-y-4">
  <TabPanel activeTab={tab} onTabChange={setTab} hideMail />
  <fieldset disabled={readOnly} className="min-w-0">
  {tab==='account'&&cloud&&typeof cloud.userData?.gold==='number'&&typeof cloud.userData?.ruby==='number'?<AccountTab cloudData={cloud} onSaveCloud={saveCloud}/>:tab==='account'?<p>Cloud data is malformed. Use Raw to repair it.</p>:null}
  {tab==='heroes'&&<HeroesTab heroes={cloud?.heroesData?.heroes??[]} onEditHero={()=>{}}/>}
  {tab==='inventory'&&<InventoryTab cloudData={cloud} onSaveCloudData={saveCloud}/>}
  {tab==='sidecontents'&&<SideContentsTab data={data} onSaveKey={onSaveKey}/>}
  {tab==='raw'&&<RawTab keys={Object.keys(data).sort().map(key=>({key}))} data={data} onSave={onSaveKey}/>}
  </fieldset>
 </div>;
}
